import { Select, Space } from "antd";
import type { CSSProperties } from "react";

const { Option } = Select;

interface SelectOption {
  id: string | number;
  name: string;
}

export interface CustomMultipleSelectAutoCompleteProps {
  value?: Array<string | number>;
  onChange?: (value: Array<string | number>) => void;
  label?: string;
  placeholder?: string;
  options?: SelectOption[];
  disabled?: boolean;
  loading?: boolean;
  error?: string;
  style?: CSSProperties;
}

const CustomMultipleSelectAutoComplete = ({
  value,
  onChange,
  label,
  placeholder = "Select",
  options = [],
  disabled = false,
  loading = false,
  error,
  style,
}: CustomMultipleSelectAutoCompleteProps) => {
  return (
    <Space direction="vertical" size={4} style={{ width: "100%" }}>
      {label && <label style={{ fontWeight: 500 }}>{label}</label>}

      <Select
        className="custom-multiple-select-autocomplete"
        mode="multiple"
        showSearch
        allowClear
        value={value}
        disabled={disabled}
        loading={loading}
        placeholder={placeholder}
        style={{ width: "100%", ...style }}
        optionFilterProp="label"
        onChange={(val) => onChange?.(val)}
        filterOption={(input, option) =>
          String(option?.label ?? "")
            .toLowerCase()
            .includes(input.toLowerCase())
        }
      >
        {options.map((item) => (
          <Option key={item.id} value={item.id} label={item.name}>
            {item.name}
          </Option>
        ))}
      </Select>

      {error && <div style={{ color: "red", fontSize: 12 }}>{error}</div>}
    </Space>
  );
};

export default CustomMultipleSelectAutoComplete;
